import { useSelector } from 'react-redux';
import { AdminAdvertisingLayout } from '../../../../common/components';
import CreateAdvertisingCampaign from '../../../common/advertising-campaign/CreateAdvertisingCampaign';
import { getUser } from '../../../../common/store';

const AdminCreateAdvertisingCampaign = () => {
    const user = useSelector(getUser);
    const orgId = user?.org?.id;

    return (
        <AdminAdvertisingLayout title="Adicionar campanha">
            <CreateAdvertisingCampaign orgId={orgId} />
        </AdminAdvertisingLayout>
    );
};

export default AdminCreateAdvertisingCampaign;
